import { useTranslation } from "react-i18next"
import { TrashSimple } from "@phosphor-icons/react"
import { AlertDialogProps } from "@radix-ui/react-alert-dialog"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

interface ConfirmDialogProps extends AlertDialogProps {
  onDiscard?(event: React.MouseEvent<HTMLElement>): void
  onConfirm?(event: React.MouseEvent<HTMLElement>): void
}

const TimeWindowDeleteDialog = ({ onDiscard, onConfirm, ...otherProps }: ConfirmDialogProps) => {
  const { t } = useTranslation()

  return (
    <AlertDialog {...otherProps} data-testid="time-window-delete-dialog">
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("patient.agenda.timeWindowForm.cancelConfirmationTitle")}</AlertDialogTitle>
          <AlertDialogDescription className="text-on-surface-subdued">
            {t("patient.agenda.timeWindowForm.cancelConfirmationSubtitle")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onConfirm} data-testid="time-window-cancel-delete-btn">
            {t("patient.agenda.timeWindowForm.cancelConfirmationContinueLabel")}
          </AlertDialogCancel>
          <AlertDialogAction
            className="btn-critical bg-critical"
            onClick={onDiscard}
            data-testid="time-window-confirm-delete-btn">
            <TrashSimple /> {t("patient.agenda.timeWindowForm.cancelConfirmationDiscardLabel")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export { TimeWindowDeleteDialog }
